module.exports = __webpack_public_path__ + "static/media/calvin-klein-euphoria-men-big.24c2abde.png";